(() => {
  if (window.BrincatoysStoryVideoLoaded) return;
  window.BrincatoysStoryVideoLoaded = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bt-story-video]');
    if (!button) return;

    const container = button.closest('[data-bt-story-video-container]');
    const videoId = button.dataset.videoId;
    if (!container || !/^[A-Za-z0-9_-]{6,20}$/.test(videoId || '')) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.title = button.textContent.trim();
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    container.replaceChildren(iframe);
    container.classList.add('is-loaded');
    iframe.focus();
  });
})();
